import React from 'react'

import logIn from '../../actions/logIn'
import {
  Button,
  ButtonNote,
} from '../../styles/buttons'
import {
  ColumnWrapper,
  FeatureImage,
} from '../../styles/onboarding'

const Onboarding = () => (
  <div>
    <h1>Relationships make life worth living.</h1>
    
    <p>More than anything else, our friends and family make us healthy and whole. Research shows that maintaining intimate, life-long relationships leads to longer life, happiness, and deeper meaning.¹</p>
    
    <p>Unfortunately, <strong>we tend to lose touch</strong> with the people that matter most. New cities, jobs, and busy schedules distract us from the regular check-ins that keep relationships alive. By the time we start to drift apart, we've lost touch.</p>

    <p>Heartstrings helps you keep your important relationships alive and well. It's a simple way to get reminders to call, email, and visit people.</p>

    <ul>
      <li>NOT a social network</li>
      <li>100% completely private (nobody will know you're using it)</li>
      <li>Works on desktop and mobile</li>
      <li>Extremely simple and easy to use</li>
      <li>Has a free plan that does not expire</li>
    </ul>

    <Button onClick={logIn}>Start getting reminders</Button>
    <ButtonNote>Requires sign-in with Google</ButtonNote>

    <br />
    <ButtonNote>1. <a href="">Research Goes Here</a></ButtonNote>

    <br />
    <hr />
    <br />
    
    <ColumnWrapper>
      <FeatureImage alt="add screen" />
      <div>
        <h3>Add friends and family</h3>
        <p>Choose how often you want to contact each person.</p>
      </div>
    </ColumnWrapper>

    <ColumnWrapper>
      <FeatureImage alt="email reminder" />
      <div>
        <h3>Get reminders to call, text, or visit</h3>
        <p>Heartstrings will send you an email reminder when it's time to reach out.</p>
      </div>
    </ColumnWrapper>

    <ColumnWrapper>
      <FeatureImage alt="track conversations" />
      <div>
        <h3>Keep track of conversations</h3>
        <p>Tap or swipe when you connect with someone.</p>
      </div>
    </ColumnWrapper>

    <ColumnWrapper>
      <FeatureImage alt="snooze screen" />
      <div>
        <h3>Snooze reminders</h3>
        <p>Not a good time? It's easy to delay individual reminders or pause all reminders for a while.</p>
      </div>
    </ColumnWrapper>

    <ColumnWrapper>
      <FeatureImage alt="filter feature" />
      <div>
        <h3>Filter and group</h3>
        <p>Group by friends, family, coworkers, or any way you like. You can even group by city to make planning visits easier.</p>
      </div>
    </ColumnWrapper>

    <hr />
    <br />

    <h3>Do I need an app for this?</h3>
    <p>Heartstrings isn't for everyone—just people who have trouble keeping in touch.</p>
    <p>If you're serious about building better habits, you need more than good intentions—you need a system. Heartstrings is a simple, humane that respects your time and helps you live a healthier life.</p>
    <p>I'm an independent app designer, and I'm on a mission to build useful things that bring people together (not distract or divide them).</p>
    <p>- Sam</p>

    <br />

    <Button onClick={logIn}>Start getting reminders</Button>
    <ButtonNote>Requires sign-in with Google</ButtonNote>

    <br />
    <br />
    <br />
    <br />

  </div>
)

export default Onboarding



// WEBPACK FOOTER //
// ./src/views/people/Onboarding.js